import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { DeliveryVoucherIndicatorType } from 'contracts/DeliveryVouchers';

export type DeliveryVoucherFilters = Partial<{
  companyId: string[];
  carrierId: string[];
  supplierId: string[];
  invoiceNumber: string;
  emissionDateFrom: string;
  emissionDateTo: string;
  deliveryDate: string;
  sameCarrierCnpj: boolean;
  originUf: string;
  originIbge: string;
  destinationUf: string;
  destinationIbge: string;
  filterIndicators: DeliveryVoucherIndicatorType;
}>;

export type DeliveryVoucherPaginationControl = {
  page: number;
  limit: number;
  orderBy?: string;
  orderByDirection?: 'asc' | 'desc';
};

type State = {
  filters: DeliveryVoucherFilters;
  paginationControl: DeliveryVoucherPaginationControl;
};

type Actions = {
  updateFilters: (filters: DeliveryVoucherFilters) => void;
  updatePaginationControl: (
    paginationControl: Partial<DeliveryVoucherPaginationControl>
  ) => void;
  clearState: () => void;
};

const getInitialState = (): State => ({
  filters: {},
  paginationControl: {
    page: 1,
    limit: 10,
  },
});

const useStore = create(
  persist<State & Actions>(
    set => ({
      ...getInitialState(),
      updateFilters: filters => set({ filters }),
      updatePaginationControl: paginationControl => {
        return set(state => ({
          paginationControl: {
            ...state.paginationControl,
            ...paginationControl,
          },
        }));
      },
      clearState: () => set(getInitialState()),
    }),
    {
      name: 'delivery-vouchers-search-params',
      version: 1,
    }
  )
);

export const useDeliveryVouchersSearchParams = () => useStore();
